webpackJsonp([40],{

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  computed: {
    email: function email() {
      return this.$store.getters.email;
    }
  },
  mounted: function mounted() {
    if (this.email === '') {
      this.$router.push('/a/');
    }
  }
});

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".box-email{background:#fff;width:320px;margin:auto;padding:20px;margin-top:20px;border-radius:20px}.email{color:#009865}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/Confirm.vue"],"names":[],"mappings":"AACA,WACE,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAoB,CACrB,AACD,OACE,aAAc,CACf","file":"Confirm.vue","sourcesContent":["\n.box-email{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 20px;\n}\n.email{\n  color: #009865\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("80034946", content, true, {});

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center info-hotsite"
  }, [_vm._v("\n    Foi enviado um e-mail para "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(", confirme seu e-mail para prosseguir com o pedido.\n  ")])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.540b891f79b160db1346.js